import React from "react"

import { ConfirmationOverlay } from "shared/ui/confirmation-overlay/ConfirmationOverlay"
import { Hint } from "shared/ui/hint/Hint"

import { zodResolver } from "@hookform/resolvers/zod"
import z from "zod"

const FORM_ID = "delete-floor-confirmation-form"

const DeleteFloorSchema = z.object({
  isConfirmed: z.literal(true)
})

type DeleteFloorFormData = {
  isConfirmed: boolean
}

interface DeleteFloorOverlayViewProps {
  headline: string
  confirmButtonText: string
  checkboxConfirmationLabel: string
  floorLabel: string
  onDelete: () => void
  onClose: () => void
}

const defaultFormValues: DeleteFloorFormData = {
  isConfirmed: false
}
const resolver = zodResolver<
  DeleteFloorFormData,
  unknown,
  z.infer<typeof DeleteFloorSchema>
>(DeleteFloorSchema)

export const DeleteFloorOverlayView = React.memo(
  ({
    headline,
    confirmButtonText,
    checkboxConfirmationLabel,
    onDelete,
    onClose
  }: DeleteFloorOverlayViewProps) => {
    return (
      <ConfirmationOverlay.Root id="delete-floor-confirmation-overlay" isDanger>
        <ConfirmationOverlay.Header>
          <ConfirmationOverlay.Title>{headline}</ConfirmationOverlay.Title>
        </ConfirmationOverlay.Header>
        <ConfirmationOverlay.Form<
          DeleteFloorFormData,
          z.infer<typeof DeleteFloorSchema>
        >
          id={FORM_ID}
          resolver={resolver}
          defaultValues={defaultFormValues}
          onSubmit={onDelete}
        >
          <Hint.Root className="hint--danger">
            <ConfirmationOverlay.CheckboxConfirmation
              name="isConfirmed"
              label={checkboxConfirmationLabel}
              className="form-check--danger"
            />
          </Hint.Root>
          <ConfirmationOverlay.Actions>
            <ConfirmationOverlay.Cancel onClick={onClose} />
            <ConfirmationOverlay.Submit form={FORM_ID}>
              {confirmButtonText}
            </ConfirmationOverlay.Submit>
          </ConfirmationOverlay.Actions>
        </ConfirmationOverlay.Form>
      </ConfirmationOverlay.Root>
    )
  }
)
